const initCompartilhamento = () => {
  const buttonsCompartilhar = document.querySelectorAll("[data-compartilhar]");

  if (buttonsCompartilhar.length > 0) {
    buttonsCompartilhar.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        compartilhar(item.dataset.compartilhar);
      });
    });

    const compartilhar = (link) => {
      if (navigator.share) {
        navigator
          .share({
            title: "Veja isso!",
            text: "Olha que conteúdo legal:\n",
            url: link,
          })
          .then(() => console.log("Compartilhado com sucesso!"))
          .catch((error) => console.error("Erro ao compartilhar:", error));
      } else {
        alert("Compartilhamento não suportado neste navegador.");
      }
    };
  }
};

export default initCompartilhamento;
